import styled from "styled-components";
import { colors } from "utils/theme";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
`;

export const CardWrapper = styled.div`
  --bg-color-1: ${colors.azure};
  --bg-color-2: ${colors.heliotrope};
  color: white;
`;

export const Footer = styled.div`
  padding-top: 24px;

  button {
    width: 100%;
  }
`;
